import { type RootState } from "features/Application/globaltypes/redux";

export const getTeamsFormSelector = (state: RootState) => state.systemNotifications.notifyStep.teamsForm;
export const getInitialTeamsFormSelector = (state: RootState) => state.systemNotifications.notifyStep.initialTeamsForm;
